<template>
  <div class="hf">
    <p class="label mb-1" v-if="label">{{ label }}</p>

    <div class="fl hf">
      <div :class="getFemaleClass()" @click="handleFemaleSelect">
        <female-icon class="icon" />
        <span>{{ 'Female' | translate }}</span>
      </div>
      <div :class="getMaleClass()" @click="handleMaleSelect">
        <male-icon class="icon" />
        <span>{{ 'Male' | translate }}</span>
      </div>
    </div>

    <div v-if="shouldShowErrors">
      <p
        v-for="(error, index) in this.errors"
        :key="index"
        class="validation-warning"
      >{{error | translate}}</p>
    </div>
  </div>
</template>

<script>
import MaleIcon from "../../0_atoms/icons/MaleIcon.vue";
import FemaleIcon from "../../0_atoms/icons/FemaleIcon.vue";

export default {
  name: "GenderSwitch",
  components: {
    MaleIcon,
    FemaleIcon
  },
  data() {
    return {
      shouldShowErrors: true
    };
  },
  props: {
    label: String,
    gender: String,
    onMaleSelect: Function,
    onFemaleSelect: Function,
    errors: null
  },
  methods: {
    getMaleClass() {
      if (this.gender === "Male") return "gender-container male active";
      else return "gender-container male";
    },
    getFemaleClass() {
      if (this.gender === "Female") return "gender-container female active";
      else return "gender-container female";
    },

    handleMaleSelect() {
      if (this.onMaleSelect != null) {
        this.shouldShowErrors = true;
        this.onMaleSelect.call();
      }
    },
    handleFemaleSelect() {
      if (this.onFemaleSelect != null) {
        this.shouldShowErrors = true;
        this.onFemaleSelect.call();
      }
    }
  }
};
</script>

<style lang='scss' scoped>
@import "../../utils/assets/stylesheets/variables.scss";

.gender-container {
  text-align: center;
  user-select: none;
  box-sizing: border-box;
  position: relative;
  height: 100%;
  width: 100%;
  padding: 11px 20px;
  cursor: pointer;
  overflow: hidden;

  span {
    color: $primary-lighten-1;
    z-index: 1 !important;
  }
  .icon {
    z-index: 0;
    stroke: $primary-lighten-1;
    fill: $primary-lighten-1;
    overflow: visible;
    stroke-width: 8;
    position: absolute;

    left: 30%;
    height: 140%;
    z-index: 0;
    opacity: 0;
    transition: all 200ms cubic-bezier(0, 0.95, 0.47, 0.92);
  }
}

.female {
  border-top-left-radius: $border-radius;
  border-bottom-left-radius: $border-radius;
  background-color: white;

  border: 1px solid $gray-lighten-1;
  border-right: 0;
  position: relative;

  .icon {
    top: -150%;
    transform: rotate(24deg);
  }

  &.active {
    border: 1px solid #ffc6e3;
    border: 1px solid #ffddee;
    background-color: #ffddee;
    font-weight: 600;

    span {
      color: #d4207d;
    }
    .icon {
      fill: #d4207d;
      stroke-width: 8;
      stroke: #d4207d;
      opacity: 0.1;
      height: 140%;
      top: -30%;
    }
  }
}

.male {
  border-top-right-radius: $border-radius;
  border-bottom-right-radius: $border-radius;
  background-color: white;
  border: 1px solid $gray-lighten-1;
  border-left: 0;
  color: $primary-lighten-1;

  .icon {
    top: 250%;
    transform: rotate(1deg);
  }

  &.active {
    border: 1px solid #b1d9ff;
    border: 1px solid #d5eaff;
    font-weight: 600;

    background-color: #d5eaff;

    span {
      color: dodgerblue;
    }
    .icon {
      fill: dodgerblue;
      stroke: dodgerblue;
      stroke-width: 8;
      opacity: 0.1;
      top: 0%;
    }
  }
}

.label {
  color: $primary-lighten-1;
}

.validation-warning {
  color: $error;
  padding-top: 7px;
  font-size: 0.9em;
}
</style>
